<template>
  <div>
    <v-dialog persistent v-model="isShowLevel" max-width="960">
      <v-card class="mx-auto" :loading="querying">
        <template slot="progress">
          <v-progress-linear
            color="green darken-3"
            height="8"
            indeterminate
          ></v-progress-linear>
        </template>

        <div class="pa-6">
          <!-- HEADER -->
          <v-row align="center">
            <!-- ICON -->
            <v-col cols="2" align="center">
              <v-avatar color="grey darken-3" size="108" class="mr-4">
                <v-icon dark size="72">mdi-tower-fire</v-icon>
              </v-avatar>
            </v-col>
            <!-- TITLE -->
            <v-col cols="8" class="mb-4">
              <v-row>
                <h1 class="text--card-title">{{ title }}</h1>
              </v-row>
              <v-row>
                <h5 class="text--card-subtitle">{{ siteTitle.title }} &nbsp;</h5>
                <h5 class="text--card-subtitle">{{ siteTitle.subTitle }}</h5>
              </v-row>
            </v-col>
            <!-- CLOSE -->
            <v-col cols="2" align="end">
              <v-icon
                @click.prevent="isCloseDescription()"
                large
                color="red darken-1"
                style="margin-bottom: 64px;"
              >
                mdi-close
              </v-icon>
            </v-col>
          </v-row>

          <!-- BODY -->
          <v-card-text class="mt-4 px-0">
            <div class="mb-2">
              <v-card outlined class="pa-4">
                <!-- HEADER -->
                <v-row align="center" class="mb-2 mx-0">
                  <h5 class="text--card-title my-1 mr-2">
                    {{ renderMeterName }}
                  </h5>
                </v-row>

                <!-- VALUE AND CHART WITH FILTER FUNCTION -->
                <v-row align="center" class="ma-0">
                  <v-col cols="12" class="pa-0">
                    <v-row class="ma-0" align="center">
                      <!-- value -->
                      <v-col cols="4" class="px-2 py-0">
                        <v-row class="ma-0" justify="center">
                          <h1 class="text--card-title text-center">{{ isNaN(sensorTotalValue) ? 'Error' : sensorTotalValue }} &nbsp; </h1>
                          <div v-html="meterUnitName"></div>
                        </v-row>
                      </v-col>

                      <!-- chart and filter function -->
                      <v-col cols="8" class="px-2 py-0">
                        <!-- filter function by period of time -->
                        <v-row class="px-2 pt-4">
                          <v-btn
                            v-for="item in btnList_datetime"
                            :key="item.id"
                            class="button-datetime-filter mx-1"
                            :color="
                              btnSelected_datetime == item.id
                                ? 'grey lighten-1'
                                : undefined
                            "
                            @click="clickFilter_datetime(item.id)"
                            depressed
                            small
                          >
                            {{ item.name }}
                          </v-btn>
                        </v-row>

                        <!-- chart -->
                        <AreaChart
                          :yData="sensorTotalSerie"
                          :yAxisName="meterType">
                        </AreaChart>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <!-- LAST UPDATED -->
                <v-row class="px-2">
                  <h5>
                    อัปเดตล่าสุด : {{ displayDate(lastUpdateDate) }}
                    {{
                      dataslot_BasedOnFilter == "60" ||
                      dataslot_BasedOnFilter == "1"
                        ? `เวลา ${lastUpdateTime}`
                        : ""
                    }}
                  </h5>
                </v-row>
              </v-card>
            </div>
          </v-card-text>

          <!-- EXPORT PDF -->
          <v-row>
            <v-col cols="12">
              <v-expansion-panels>
                <v-expansion-panel>
                  <!-- HEADER -->
                  <v-expansion-panel-header style="padding: 0px 10px">
                    <v-col cols="2" align="center">
                      <v-avatar color="grey darken-3" size="48" class="">
                        <v-icon dark size="36">mdi-download</v-icon>
                      </v-avatar>
                    </v-col>
                    <v-col cols="10">
                      <h3>ดาวน์โหลดข้อมูล</h3>
                    </v-col>
                  </v-expansion-panel-header>
                  <!-- CONTENT -->
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="postData.startDate"
                              label="เริ่มวันที่"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="postData.startDate"
                            @input="menu = false"
                            :max="currentDate"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-menu
                          v-model="menu2"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="postData.endDate"
                              label="สิ้นสุดวันที่"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="postData.endDate"
                            :min="postData.startDate"
                            :max="currentDate"
                            @input="menu2 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <!-- PREVIEW BUTTON -->
                    <v-row class="pb-4" align="center" justify="center">
                      <v-btn @click="setPostData()" color="success" large dark>
                        <p class="mb-0">แสดงตัวอย่างเพื่อดาวน์โหลด</p>
                      </v-btn>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import services from "@/services/services";
import AreaChart from "@/components/visuals/AreaChart.vue";

export default {
  name: "LevelMeterModal",

  components: {
    AreaChart
  },

  props: {
    isShowLevel: {
      type: Boolean,
      default: false,
    },
    groupId: {
      type: String,
      default: "",
    },
    meterType: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    deviceId: {
      type: String,
      default: "",
    },
    siteTitle: {
      type: Object,
      default() {
        return {
          title: "",
          subTitle: "",
        }
      }
    },
  },

  data: function() {
    return {
      querying: false,

      // CURRENT_VALUE
      sensorTotalValue: 500,

      // LAST UPDATE (DATE/TIME)
      lastUpdateDate: "",
      lastUpdateTime: "",

      // SERIES_VALUE
      sensorTotalSerie: [
        {
          x: "",
          y: 0,
        },
      ],

      // PERIOD_TYPE_FILTER
      btnList_datetime: [
        { id: 0, name: "Hour", titleTh: "ชั่วโมง" },
        { id: 1, name: "Day", titleTh: "วัน" },
        { id: 2, name: "Week", titleTh: "สัปดาห์" },
        { id: 3, name: "Month", titleTh: "เดือน" },
        { id: 4, name: "Year", titleTh: "ปี" },
      ],
      dataslot_BasedOnFilter: 60,
      btnSelected_datetime: 0,

      chartName: "ระดับน้ำ",
      sensorError: false,
      curLevelVal: 0,

      currentDate: moment().format("YYYY-MM-DD"),
      menu: false,
      menu2: false,
      postData: {
        deviceId: "",
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      // UnMOUNTED
      polling: null,
    };
  },

  computed: {
    meterUnitName() {
      if(this.deviceId === '4708130201001' || this.deviceId === '4708130201002') {
        return `<h1 class="text--card-title text-center"> PPM </h1>`;
      } else {
        return `<h1 class="text--card-title text-center"> M<sup>3</sup> </h1>`;
      }
    },
    renderMeterName() {
      if(this.deviceId === '4708130201001' || this.deviceId === '4708130201002') {
        return 'ค่าสารละลายในน้ำ (TDS - Total dissolved solids)';
      } else {
        return 'ค่าปริมาตรน้ำ (Volume)';
      }
    }
  },

  watch: {
    dataslot_BasedOnFilter: function() {
      this.queryDataByPeriod();
    },
  },

  methods: {
    isCloseDescription() {
      this.$emit("onCloseModal", true);
    },
    clickFilter_datetime(id) {
      // console.log('ID: ', id);
      this.btnSelected_datetime = id;
      switch (id) {
        // Hours
        case 0:
          this.dataslot_BasedOnFilter = 60;
          break;
        // Days
        case 1:
          this.dataslot_BasedOnFilter = 1;
          break;
        // Weeks
        case 2:
          this.dataslot_BasedOnFilter = 7;
          break;
        // Months
        case 3:
          this.dataslot_BasedOnFilter = 30;
          break;
        // Years
        case 4:
          this.dataslot_BasedOnFilter = 365;
          break;

        default:
          this.dataslot_BasedOnFilter = 60;
          break;
      }
    },
    displayDate(date) {
      return moment(date, "YYYY-MM-DD").format("วันddddที่ Do MMMM YYYY");
    },
    setPostData() {
      // console.log("deviceId", this.deviceId);
      let routeData = this.$router.resolve({
        path: "/export",
        query: {
          deviceId: this.deviceId,
          startDate: this.postData.startDate,
          endDate: this.postData.endDate,
        },
      });
      window.open(routeData.href, "_blank");
    },
    // API
    async queryDataByPeriod() {
      this.querying = true;
      let postData = { 'limit': this.dataslot_BasedOnFilter };
      let res = await services.getMeterDataByPeriod(postData);
      if (res) {
        // console.log('RES.DATA:', res['data']);
        let _res = res['data']['iot_470813'];
        // ! IN KHON-KAEN ONLY
        if (this.deviceId === '4708130201001' || this.deviceId === '4708130201002') {
          this.setLastUpdateDateTime(_res[0]);
          this.setMeterValueCurrent(_res[0], "TDS");
          this.setMeterValueSeries(_res, "TDS");
        } else {
          this.setLastUpdateDateTime(_res[0]);
          this.setMeterValueCurrent(_res[0]);
          this.setMeterValueSeries(_res);
        }
      }
      this.querying = false;
    },
    mountQuery() {
      this.polling = setInterval(async () => {
        await this.queryDataByPeriod();
      }, 10 * 1000);
    },
    // afterQuery
    setLastUpdateDateTime(data) {
      this.lastUpdateDate = data['date'];
      this.lastUpdateTime = data['time'];
    },
    setMeterValueCurrent(data, sensorTypeTitle="LEVEL_VOLUME") {
      let sensorTotalId = this.deviceId + sensorTypeTitle;
      if (this.deviceId === "4015080300301") {
        this.sensorTotalValue = (Number.parseFloat(data[sensorTotalId]) * 111.11).toFixed(2);
      } else {
        this.sensorTotalValue = Number.parseFloat(data[sensorTotalId]).toFixed(2);
      }
    },
    setMeterValueSeries(data, sensorTypeTitle="LEVEL_VOLUME") {
      let sensorTotalId = this.deviceId + sensorTypeTitle;
      if (this.deviceId === "4015080300301") {
        this.sensorTotalSerie = this.calMeterValueByColumn(data, sensorTotalId, 111.11);
      } else {
        this.sensorTotalSerie = this.calMeterValueByColumn(data, sensorTotalId);
      }
    },
    calMeterValueByColumn(data, colName, calMultiply=1) {
      let dataSeries = [];
      for (let index = data.length-1; index >= 0; index--) {
        let colData = {
          y: (Number.parseFloat(data[index][colName])*calMultiply).toFixed(2),
          x: data[index]['time'] ? data[index]['time'] : data[index]['date']
        };
        dataSeries.push(colData);
      }
      return dataSeries;
    },
  },

  created() {
    moment.locale("th");
  },

  mounted() {
    this.queryDataByPeriod();
    this.mountQuery();
  },

  beforeDestroy() {
    clearInterval(this.polling);
  },
};
</script>

<style>
.button-datetime-filter {
  width: 84px;
}
</style>
